import { Link, useNavigate } from "react-router-dom";
import { MapPin, Star, Heart } from "@phosphor-icons/react";
import { useAuth } from "@/contexts/AuthContext";
import { toast } from "sonner";

const API_URL = process.env.REACT_APP_BACKEND_URL;

export default function ItemCard({ item }) {
  const { user, wishlistIds, toggleWishlist } = useAuth();
  const navigate = useNavigate();
  const imageUrl = item.images?.[0]
    ? `${API_URL}/api/files/${item.images[0]}`
    : "https://images.unsplash.com/photo-1650368237704-bf3d79a8b6b4?w=400&q=80";

  const isWishlisted = wishlistIds?.has(item.id);

  const handleWishlist = async (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (!user) { navigate("/login"); return; }
    const ok = await toggleWishlist(item.id);
    if (ok) toast.success(isWishlisted ? "Removed from wishlist" : "Added to wishlist");
  };

  return (
    <Link
      to={`/item/${item.id}`}
      className="item-card block bg-white border border-[#EAE7E0] rounded-2xl overflow-hidden group relative"
      data-testid={`item-card-${item.id}`}
    >
      <div className="aspect-[4/3] overflow-hidden bg-[#F5F3EE] relative">
        <img src={imageUrl} alt={item.title} className="w-full h-full object-cover img-zoom" loading="lazy" />
        <button
          onClick={handleWishlist}
          className="absolute top-3 right-3 w-8 h-8 bg-white/80 backdrop-blur-sm rounded-full flex items-center justify-center transition-all hover:bg-white hover:scale-110 z-10"
          data-testid={`wishlist-btn-${item.id}`}
        >
          <Heart size={16} weight={isWishlisted ? "fill" : "regular"} className={isWishlisted ? "text-[#D96C4A]" : "text-[#5C665D]"} />
        </button>
      </div>
      <div className="p-4">
        <p className="overline text-[#D96C4A] mb-1">{item.category?.replace(/_/g, " ")}</p>
        <h3 className="font-heading text-lg font-medium text-[#1A1C1A] leading-snug mb-1 line-clamp-1">{item.title}</h3>
        <div className="flex items-center gap-1 text-xs text-[#5C665D] mb-2">
          <MapPin size={12} weight="duotone" />
          <span className="line-clamp-1">{item.location || "Location not set"}</span>
        </div>
        <div className="flex items-center justify-between">
          <p className="text-[#2C5545] font-semibold">
            ${item.price_per_day?.toFixed(2)}<span className="text-xs font-normal text-[#5C665D]">/day</span>
          </p>
          {item.avg_rating > 0 && (
            <div className="flex items-center gap-1 text-xs">
              <Star size={12} weight="fill" className="text-[#E8A341]" />
              <span className="text-[#5C665D]">{item.avg_rating}</span>
            </div>
          )}
        </div>
      </div>
    </Link>
  );
}
